module.exports = __webpack_public_path__ + "img/w58.06c6c940.svg";